const state = {
    window: {
        windowHeight: null,
        windowWidth: null,
        scrollY: null
    },

    inputHasFocus: false
};

export default state;



// WEBPACK FOOTER //
// ./src/store/Screen/state.js